import generateTypes from '../utils/generateTypes';

export const GET_REPORTS = generateTypes('GET_REPORTS');
export const RESET_REPORTS = generateTypes('RESET_REPORTS');
